export default __webpack_public_path__ + "static/media/typing.546df8e1.gif";